import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useForm } from 'react-hook-form';
import { CreateChancel, SelectAutocompleteMultiple } from 'components';
import { httpRequestsOnSuccessActions, taskActions } from 'store';
import { FindLoad, useModal, FindSuccessItem } from 'utils';
import { taskStatusList } from '../constants';

const ACTION_TYPE = 'BULK_UPDATE_TASK_STATUS';

export const ChangeTaskStatus = ({ selectedIds, afterSuccess, renderParams }) => {
    const { watch, handleSubmit, control, reset } = useForm();
    const dispatch = useDispatch();
    const success = FindSuccessItem(ACTION_TYPE);
    const loader = FindLoad(ACTION_TYPE);
    const { close } = useModal();

    useEffect(() => {
        if (success) {
            dispatch(httpRequestsOnSuccessActions.removeSuccess(ACTION_TYPE));
            close();
            afterSuccess();
        }
    }, [success]);

    const handleCreate = (data) => {
        dispatch(taskActions.bulkUpdateTaskStatus({ ids: selectedIds, status: data?.status }, renderParams));
    };

    return (
        <div style={{ width: 400 }}>
            <p className="modal-header-title">Change Status</p>
            <p className="modal-header-sub">{`Apply a new status to ${selectedIds?.length} selected tasks.`}</p>
            <form onSubmit={handleSubmit(handleCreate)}>
                <div className="modal-body-wrapper">
                    <SelectAutocompleteMultiple
                        renderValue={(i) => i?.name}
                        options={taskStatusList}
                        label={'Status*'}
                        name="status"
                        control={control}
                        rules={{
                            required: 'Status is required.',
                        }}
                    />
                </div>
                <CreateChancel
                    type="submit"
                    loader={!!loader.length}
                    create={'Change Status'}
                    chancel={'Cancel'}
                    onClose={close}
                    buttonWidth="100%"
                    cancelRight={'24px'}
                />
            </form>
        </div>
    );
};
